	<template>
  <div>
    <hr />

    <!-- Búsqueda -->
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td>
              <label class="form-label">Descripción</label>
              <input
                type="text"
                class="form-control"
                v-model="descripcionBusqueda"
                @input="filtrarRegistros"
                style="width: 400px; text-transform: uppercase"
              />
            </td>
            <td class="centro">
              <button class="btn btn-light" @click="refrescarDatos">
                <span class="material-icons" style="color: blue">auto_awesome_motion</span>
                Refrescar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Tabla de registros -->
    <div v-if="cargando" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <table v-else class="table table-striped">
      <thead>
        <tr>
          <th>Código</th>
          <th>Descripción</th>
          <th class="text-center">Veces enviado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(r, index) in registrosPaginados"
          :key="`${r.codigo}-${index}`"
          @dblclick="abrirModalDetalle(r)"
          style="cursor: pointer"
          class="hover-row"
        >
          <td>{{ r.codigo }}</td>
          <td>{{ r.descripcion }}</td>
          <td class="text-center">{{ r.contador }}</td>
        </tr>
        <tr v-if="registrosPaginados.length === 0">
          <td colspan="3" class="text-center text-muted">
            No se encontraron registros
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginación -->
    <nav v-if="registrosFiltrados.length > 0" aria-label="Navegación de páginas">
      <ul class="pagination">
        <li class="page-item" :class="{ disabled: paginaActual === 1 }">
          <a class="page-link" href="#" @click.prevent="getPreviousPage">Anterior</a>
        </li>
        <li
          v-for="pagina in paginasVisibles"
          :key="pagina"
          @click.prevent="cambiarPagina(pagina)"
          class="page-item"
          :class="{ active: pagina === paginaActual }"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
          <a class="page-link" href="#" @click.prevent="getNextPage">Siguiente</a>
        </li>
      </ul>
      <div class="text-muted small">
        Mostrando {{ rangoInicio }} - {{ rangoFin }} de {{ registrosFiltrados.length }} registros
      </div>
    </nav>

    <!-- Modal Detalle -->
    <Teleport to="body">
      <div
        class="modal fade"
        id="modalDetalle"
        tabindex="-1"
        aria-labelledby="modalDetalleLabel"
        aria-hidden="true"
        ref="modalElement"
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="modalDetalleLabel">
                <span class="material-icons align-middle me-2" style="font-size: 24px">link</span>
                Mapeo de Elemento
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                @click="cerrarModal"
                aria-label="Cerrar"
              ></button>
            </div>
            <div class="modal-body">

              <!-- Información del registro -->
              <div class="info-registro mb-4">
                <div class="row">
                  <div class="col-md-4">
                    <strong class="text-muted">Código:</strong>
                    <div class="h5">{{ registroSeleccionado.codigo }}</div>
                  </div>
                  <div class="col-md-6">
                    <strong class="text-muted">Descripción:</strong>
                    <div class="h5 text-uppercase">{{ registroSeleccionado.descripcion }}</div>
                  </div>
                  <div class="col-md-2">
                    <strong class="text-muted">Veces enviado:</strong>
                    <div class="h5">
                      <span class="badge bg-secondary">{{ registroSeleccionado.contador }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div class="row mb-3 align-items-end">
                <div class="col-md-3">
                  <label class="form-label fw-bold">Aplicable</label>
                  <select class="form-select" v-model="aplicable">
                    <option :value="1">Sí</option>
                    <option :value="0">No</option>
                  </select>
                </div>
                <div class="col-md-6" v-show="aplicable === 0">
                  <label class="form-label fw-bold">
                    Observación
                    <span class="text-danger ms-1">*</span>
                  </label>
                  <select
                    class="form-select"
                    v-model="observacion"
                    :class="{ 'is-invalid': !observacion }"
                  >
                    <option value="">-- Sin observación --</option>
                    <option value="No se cubre este tipo de insumos.">
                      No se cubre este tipo de insumos.
                    </option>
                    <option value="Medicamento fuera del CNMB">
                      Medicamento fuera del CNMB
                    </option>
                  </select>
                  <div v-if="!observacion" class="invalid-feedback">
                    Seleccione una observación para poder mapear
                  </div>
                </div>
                <div class="col-md-3" v-show="aplicable === 0">
                  <button
                    class="btn btn-secondary btn-lg w-100"
                    @click="mapearNoAplicable"
                    :disabled="!observacion || procesandoMapeo"
                  >
                    <span v-if="procesandoMapeo" class="spinner-border spinner-border-sm me-2"></span>
                    <span v-else class="material-icons align-middle me-1" style="font-size: 20px">
                      block
                    </span>
                    Mapeo no aplicable
                  </button>
                </div>
              </div>

              <hr />

              <!-- Tabs de mapeo -->
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="prestacion-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#prestacion"
                    type="button"
                    role="tab"
                    aria-controls="prestacion"
                    aria-selected="true"
                    @click="tabActual = 'prestacion'"
                  >
                    <span class="material-icons align-middle" style="font-size: 20px">medical_services</span>
                    Prestación
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="medicamento-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#medicamento"
                    type="button"
                    role="tab"
                    aria-controls="medicamento"
                    aria-selected="false"
                    @click="tabActual = 'medicamento'"
                  >
                    <span class="material-icons align-middle" style="font-size: 20px">medication</span>
                    Medicamento
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="insumo-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#insumo"
                    type="button"
                    role="tab"
                    aria-controls="insumo"
                    aria-selected="false"
                    @click="tabActual = 'insumo'"
                  >
                    <span class="material-icons align-middle" style="font-size: 20px">inventory_2</span>
                    Insumo
                  </button>
                </li>
              </ul>

              <div class="tab-content mt-3">

                <!-- Tab Prestación -->
                <div
                  class="tab-pane fade show active"
                  id="prestacion"
                  role="tabpanel"
                  aria-labelledby="prestacion-tab"
                >
                  <div class="row">
                    <div class="col-md-8">
                      <div class="mb-3">
                        <label class="form-label fw-bold">
                          Buscar Prestación (Exámenes y Procedimientos)
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          v-model="busquedaPrestacion"
                          @input="buscarPrestaciones"
                          placeholder="Escriba para buscar prestación..."
                          style="text-transform: uppercase"
                        />
                        <small v-if="cargandoPrestaciones" class="text-muted">
                          <span class="spinner-border spinner-border-sm me-1"></span>
                          Buscando prestaciones...
                        </small>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Resultados de búsqueda</label>
                        <select
                          class="form-select form-select-lg"
                          v-model="prestacionSeleccionada"
                          :disabled="cargandoPrestaciones"
                          size="8"
                        >
                          <option disabled value="">
                            {{ prestaciones.length === 0 && !busquedaPrestacion
                              ? '-- Escriba para buscar prestación --'
                              : '-- Seleccione una prestación --'
                            }}
                          </option>
                          <option
                            v-for="p in prestaciones"
                            :key="p.idTarifaPres"
                            :value="p"
                          >
                            {{ p.elementoCodigo }} - {{ p.elementoNombre }} | ${{ p.valor.toFixed(2) }}
                          </option>
                        </select>
                        <div
                          v-if="prestaciones.length === 0 && busquedaPrestacion && !cargandoPrestaciones"
                          class="text-muted small mt-2"
                        >
                          <span class="material-icons align-middle" style="font-size: 16px">info</span>
                          No se encontraron prestaciones con ese criterio
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-header bg-info text-white">
                          <strong>Detalle de Prestación</strong>
                        </div>
                        <div class="card-body">
                          <div v-if="prestacionSeleccionada">
                            <div class="mb-2">
                              <small class="text-muted">Código</small>
                              <div class="fw-bold">{{ prestacionSeleccionada.elementoCodigo }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Nombre</small>
                              <div class="fw-bold">{{ prestacionSeleccionada.elementoNombre }}</div>
                            </div>
                            <hr />
                            <div class="mb-2">
                              <small class="text-muted">Prestador</small>
                              <div>{{ prestacionSeleccionada.prestadorNombreComercial }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Tarifa</small>
                              <div>{{ prestacionSeleccionada.tarifaConvNombre }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Valor</small>
                              <div class="h4 text-success mb-0">
                                ${{ prestacionSeleccionada.valor.toFixed(2) }}
                              </div>
                            </div>
                          </div>
                          <div v-else class="text-center text-muted py-4">
                            <span
                              class="material-icons d-block mb-2"
                              style="font-size: 48px; opacity: 0.3"
                            >medical_services</span>
                            <p class="mb-0">Seleccione una prestación</p>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-info btn-lg w-100 mt-3 text-white"
                        @click="mapearPrestacion"
                        :disabled="!prestacionSeleccionada || aplicable === 0 || procesandoMapeo"
                      >
                        <span v-if="procesandoMapeo" class="spinner-border spinner-border-sm me-2"></span>
                        <span v-else class="material-icons align-middle me-1" style="font-size: 20px">
                          check_circle
                        </span>
                        Mapear a Prestación
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Tab Medicamento -->
                <div
                  class="tab-pane fade"
                  id="medicamento"
                  role="tabpanel"
                  aria-labelledby="medicamento-tab"
                >
                  <div class="row">
                    <div class="col-md-8">
                      <div class="mb-3">
                        <label class="form-label fw-bold">Buscar Medicamento</label>
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          v-model="busquedaMedicamento"
                          @input="buscarMedicamentos"
                          placeholder="Escriba para buscar medicamento..."
                          style="text-transform: uppercase"
                        />
                        <small v-if="cargandoMedicamentos" class="text-muted">
                          <span class="spinner-border spinner-border-sm me-1"></span>
                          Buscando medicamentos...
                        </small>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Resultados de búsqueda</label>
                        <select
                          class="form-select form-select-lg"
                          v-model="medicamentoSeleccionado"
                          :disabled="cargandoMedicamentos"
                          size="8"
                        >
                          <option disabled value="">
                            {{ medicamentos.length === 0 && !busquedaMedicamento
                              ? '-- Escriba para buscar medicamento --'
                              : '-- Seleccione un medicamento --'
                            }}
                          </option>
                          <option
                            v-for="m in medicamentos"
                            :key="m.idElemento"
                            :value="m"
                          >
                            {{ m.codigo }} - {{ m.nombre }}
                          </option>
                        </select>
                        <div
                          v-if="medicamentos.length === 0 && busquedaMedicamento && !cargandoMedicamentos"
                          class="text-muted small mt-2"
                        >
                          <span class="material-icons align-middle" style="font-size: 16px">info</span>
                          No se encontraron medicamentos con ese criterio
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-header bg-success text-white">
                          <strong>Detalle de Medicamento</strong>
                        </div>
                        <div class="card-body">
                          <div v-if="medicamentoSeleccionado">
                            <div class="mb-2">
                              <small class="text-muted">Código</small>
                              <div class="fw-bold">{{ medicamentoSeleccionado.codigo }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Nombre</small>
                              <div class="fw-bold">{{ medicamentoSeleccionado.nombre }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Clasificación</small>
                              <div>{{ medicamentoSeleccionado.clasElemNombre }}</div>
                            </div>
                          </div>
                          <div v-else class="text-center text-muted py-4">
                            <span
                              class="material-icons d-block mb-2"
                              style="font-size: 48px; opacity: 0.3"
                            >medication</span>
                            <p class="mb-0">Seleccione un medicamento</p>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-success btn-lg w-100 mt-3"
                        @click="mapearMedicamento"
                        :disabled="!medicamentoSeleccionado || aplicable === 0 || procesandoMapeo"
                      >
                        <span v-if="procesandoMapeo" class="spinner-border spinner-border-sm me-2"></span>
                        <span v-else class="material-icons align-middle me-1" style="font-size: 20px">
                          check_circle
                        </span>
                        Mapear a Medicamento
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Tab Insumo -->
                <div
                  class="tab-pane fade"
                  id="insumo"
                  role="tabpanel"
                  aria-labelledby="insumo-tab"
                >
                  <div class="row">
                    <div class="col-md-8">
                      <div class="mb-3">
                        <label class="form-label fw-bold">Buscar Insumo</label>
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          v-model="busquedaInsumo"
                          @input="buscarInsumos"
                          placeholder="Escriba para buscar insumo..."
                          style="text-transform: uppercase"
                        />
                        <small v-if="cargandoInsumos" class="text-muted">
                          <span class="spinner-border spinner-border-sm me-1"></span>
                          Buscando insumos...
                        </small>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Resultados de búsqueda</label>
                        <select
                          class="form-select form-select-lg"
                          v-model="insumoSeleccionado"
                          :disabled="cargandoInsumos"
                          size="8"
                        >
                          <option disabled value="">
                            {{ insumos.length === 0 && !busquedaInsumo
                              ? '-- Escriba para buscar insumo --'
                              : '-- Seleccione un insumo --'
                            }}
                          </option>
                          <option
                            v-for="i in insumos"
                            :key="i.idElemento"
                            :value="i"
                          >
                            {{ i.codigo }} - {{ i.nombre }}
                          </option>
                        </select>
                        <div
                          v-if="insumos.length === 0 && busquedaInsumo && !cargandoInsumos"
                          class="text-muted small mt-2"
                        >
                          <span class="material-icons align-middle" style="font-size: 16px">info</span>
                          No se encontraron insumos con ese criterio
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-header bg-warning text-dark">
                          <strong>Detalle de Insumo</strong>
                        </div>
                        <div class="card-body">
                          <div v-if="insumoSeleccionado">
                            <div class="mb-2">
                              <small class="text-muted">Código</small>
                              <div class="fw-bold">{{ insumoSeleccionado.codigo }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Nombre</small>
                              <div class="fw-bold">{{ insumoSeleccionado.nombre }}</div>
                            </div>
                            <div class="mb-2">
                              <small class="text-muted">Clasificación</small>
                              <div>{{ insumoSeleccionado.clasElemNombre }}</div>
                            </div>
                          </div>
                          <div v-else class="text-center text-muted py-4">
                            <span
                              class="material-icons d-block mb-2"
                              style="font-size: 48px; opacity: 0.3"
                            >inventory_2</span>
                            <p class="mb-0">Seleccione un insumo</p>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-warning btn-lg w-100 mt-3"
                        @click="mapearInsumo"
                        :disabled="!insumoSeleccionado || aplicable === 0 || procesandoMapeo"
                      >
                        <span v-if="procesandoMapeo" class="spinner-border spinner-border-sm me-2"></span>
                        <span v-else class="material-icons align-middle me-1" style="font-size: 20px">
                          check_circle
                        </span>
                        Mapear a Insumo
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import api from "@/services/api";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";

export default {
  name: "MapeoElementos",

  props: {
    p_idTramite: {
      type: Number,
      required: true,
    },
    p_idPrestador: {
      type: Number,
      required: false,
      default: 1,
    },
  },

  data() {
    return {
      registros: [],
      descripcionBusqueda: "",
      elementosPorPagina: 10,
      paginaActual: 1,
      registroSeleccionado: {},
      medicamentos: [],
      insumos: [],
      prestaciones: [],
      medicamentoSeleccionado: "",
      insumoSeleccionado: "",
      prestacionSeleccionada: "",
      busquedaMedicamento: "",
      busquedaInsumo: "",
      busquedaPrestacion: "",
      tabActual: "prestacion",
      aplicable: 1,
      observacion: "",
      observacionOpciones: [
        "No se cubre este tipo de insumos.",
        "Medicamento fuera del CNMB",
      ],
      modalInstance: null,
      cargando: false,
      error: null,
      cargandoMedicamentos: false,
      cargandoInsumos: false,
      cargandoPrestaciones: false,
      procesandoMapeo: false,
      debounceTimerMedicamentos: null,
      debounceTimerInsumos: null,
      debounceTimerPrestaciones: null,
      idPrestadorEfectivo: null,
    };
  },

  computed: {
    registrosFiltrados() {
      if (!this.descripcionBusqueda.trim()) {
        return this.registros;
      }
      const busqueda = this.descripcionBusqueda.toLowerCase();
      return this.registros.filter(
        (r) =>
          r.descripcion.toLowerCase().includes(busqueda) ||
          r.codigo.toLowerCase().includes(busqueda)
      );
    },

    totalPaginas() {
      return Math.ceil(this.registrosFiltrados.length / this.elementosPorPagina);
    },

    registrosPaginados() {
      const inicio = (this.paginaActual - 1) * this.elementosPorPagina;
      const fin = inicio + this.elementosPorPagina;
      return this.registrosFiltrados.slice(inicio, fin);
    },

    paginasVisibles() {
      const paginas = [];
      const maxPaginas = 5;
      let inicio = Math.max(1, this.paginaActual - Math.floor(maxPaginas / 2));
      let fin = Math.min(this.totalPaginas, inicio + maxPaginas - 1);
      if (fin - inicio < maxPaginas - 1) {
        inicio = Math.max(1, fin - maxPaginas + 1);
      }
      for (let i = inicio; i <= fin; i++) {
        paginas.push(i);
      }
      return paginas;
    },

    rangoInicio() {
      return (this.paginaActual - 1) * this.elementosPorPagina + 1;
    },

    rangoFin() {
      return Math.min(
        this.paginaActual * this.elementosPorPagina,
        this.registrosFiltrados.length
      );
    },
  },

  watch: {
    aplicable(val) {
      if (val === 1) this.observacion = "";
    },
  },

  async mounted() {
    try {
      const res = await api.get(`/vwprestadors/${this.p_idPrestador}`);
      const prestador = res.data;
      this.idPrestadorEfectivo = prestador.idPrestadorPadre ?? this.p_idPrestador;
    } catch {
      this.idPrestadorEfectivo = this.p_idPrestador;
    }

    this.cargarDatos();
    this.inicializarModal();
  },

  beforeUnmount() {
    if (this.debounceTimerMedicamentos) clearTimeout(this.debounceTimerMedicamentos);
    if (this.debounceTimerInsumos)      clearTimeout(this.debounceTimerInsumos);
    if (this.debounceTimerPrestaciones) clearTimeout(this.debounceTimerPrestaciones);
    if (this.modalInstance)             this.modalInstance.dispose();
  },

  methods: {
    async cargarDatos() {
      this.cargando = true;
      this.error = null;
      try {
        const response = await api.get(
          `/vwmapeoelemento/por-tramite/${this.p_idTramite}`
        );
        this.registros = response.data;
        this.paginaActual = 1;
      } catch (err) {
        this.error = "Error al cargar los datos: " + (err.message || "Error desconocido");
        console.error("Error cargando datos:", err);
        Swal.fire({
          icon: "error",
          title: "Error al cargar datos",
          text: err.message || "Error desconocido",
          confirmButtonColor: "#0d6efd",
        });
      } finally {
        this.cargando = false;
      }
    },

    refrescarDatos() {
      this.descripcionBusqueda = "";
      this.cargarDatos();
    },

    filtrarRegistros() {
      this.paginaActual = 1;
    },

    cambiarPagina(pagina) {
      if (pagina >= 1 && pagina <= this.totalPaginas) {
        this.paginaActual = pagina;
      }
    },

    getPreviousPage() {
      if (this.paginaActual > 1) this.paginaActual--;
    },

    getNextPage() {
      if (this.paginaActual < this.totalPaginas) this.paginaActual++;
    },

    inicializarModal() {
      this.$nextTick(() => {
        const modalElement = this.$refs.modalElement;
        if (modalElement) {
          this.modalInstance = new Modal(modalElement);
        }
      });
    },

    async abrirModalDetalle(registro) {
      this.registroSeleccionado = { ...registro };
      this.medicamentoSeleccionado = "";
      this.insumoSeleccionado = "";
      this.prestacionSeleccionada = "";
      this.busquedaMedicamento = "";
      this.busquedaInsumo = "";
      this.busquedaPrestacion = "";
      this.medicamentos = [];
      this.insumos = [];
      this.prestaciones = [];
      this.tabActual = "prestacion";
      this.aplicable = 1;
      this.observacion = "";

      this.busquedaPrestacion = registro.descripcion || "";
      this.busquedaMedicamento = registro.descripcion || "";
      this.busquedaInsumo = registro.descripcion || "";

      await this.ejecutarBusquedaPrestaciones();

      if (this.modalInstance) {
        this.modalInstance.show();
      }
    },

    cerrarModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    // ── Búsquedas con debounce ────────────────────────────────────────────

    buscarMedicamentos() {
      if (this.debounceTimerMedicamentos) clearTimeout(this.debounceTimerMedicamentos);
      this.medicamentoSeleccionado = "";
      if (!this.busquedaMedicamento.trim()) {
        this.medicamentos = [];
        return;
      }
      this.debounceTimerMedicamentos = setTimeout(
        () => this.ejecutarBusquedaMedicamentos(),
        500
      );
    },

    async ejecutarBusquedaMedicamentos() {
      const searchTerm = this.busquedaMedicamento.trim();
      if (!searchTerm) { this.medicamentos = []; return; }
      this.cargandoMedicamentos = true;
      try {
        const response = await api.get(
          `/vwelementos/idclaselem-search/10?search=${encodeURIComponent(searchTerm)}`
        );
        this.medicamentos = response.data;
      } catch (err) {
        console.error("Error buscando medicamentos:", err);
        this.medicamentos = [];
        if (err.response && err.response.status !== 404) {
          Swal.fire({
            icon: "error", title: "Error al buscar",
            text: "No se pudieron cargar los medicamentos",
            toast: true, position: "top-end",
            showConfirmButton: false, timer: 3000, timerProgressBar: true,
          });
        }
      } finally {
        this.cargandoMedicamentos = false;
      }
    },

    buscarInsumos() {
      if (this.debounceTimerInsumos) clearTimeout(this.debounceTimerInsumos);
      this.insumoSeleccionado = "";
      if (!this.busquedaInsumo.trim()) {
        this.insumos = [];
        return;
      }
      this.debounceTimerInsumos = setTimeout(
        () => this.ejecutarBusquedaInsumos(),
        500
      );
    },

    async ejecutarBusquedaInsumos() {
      const searchTerm = this.busquedaInsumo.trim();
      if (!searchTerm) { this.insumos = []; return; }
      this.cargandoInsumos = true;
      try {
        const response = await api.get(
          `/vwelementos/idclaselem-search/11?search=${encodeURIComponent(searchTerm)}`
        );
        this.insumos = response.data;
      } catch (err) {
        console.error("Error buscando insumos:", err);
        this.insumos = [];
        if (err.response && err.response.status !== 404) {
          Swal.fire({
            icon: "error", title: "Error al buscar",
            text: "No se pudieron cargar los insumos",
            toast: true, position: "top-end",
            showConfirmButton: false, timer: 3000, timerProgressBar: true,
          });
        }
      } finally {
        this.cargandoInsumos = false;
      }
    },

    buscarPrestaciones() {
      if (this.debounceTimerPrestaciones) clearTimeout(this.debounceTimerPrestaciones);
      this.prestacionSeleccionada = "";
      if (!this.busquedaPrestacion.trim()) {
        this.prestaciones = [];
        return;
      }
      this.debounceTimerPrestaciones = setTimeout(
        () => this.ejecutarBusquedaPrestaciones(),
        500
      );
    },

    async ejecutarBusquedaPrestaciones() {
      const searchTerm = this.busquedaPrestacion.trim();
      if (!searchTerm) {
        this.prestaciones = [];
        return;
      }
      this.cargandoPrestaciones = true;
      try {
        const response = await api.get(
          `/vwtarifapress/search-prestador?idprestador=${this.idPrestadorEfectivo}&search=${encodeURIComponent(searchTerm)}`
        );
        this.prestaciones = response.data;
      } catch (err) {
        console.error("Error buscando prestaciones:", err);
        this.prestaciones = [];
        if (err.response && err.response.status !== 404) {
          Swal.fire({
            icon: "error", title: "Error al buscar",
            text: "No se pudieron cargar las prestaciones",
            toast: true, position: "top-end",
            showConfirmButton: false, timer: 3000, timerProgressBar: true,
          });
        }
      } finally {
        this.cargandoPrestaciones = false;
      }
    },

    // ── Helper: params comunes para todos los mapeos ──────────────────────
    _paramsMapeo(idElemento = 0) {
      return {
        idTramite:   this.p_idTramite,
        codigo:      String(this.registroSeleccionado.codigo),
        descripcion: this.registroSeleccionado.descripcion,
        idElemento:  idElemento ?? 0,
        idPrestador: this.p_idPrestador,
        aplicable:   this.aplicable,
        observacion: this.observacion || "",
      };
    },

    // ── Mapeo no aplicable ────────────────────────────────────────────────
    async mapearNoAplicable() {
      if (!this.observacion) return;

      const result = await Swal.fire({
        title: "¿Confirmar mapeo no aplicable?",
        html: `
          <div class="text-start">
            <p><strong>Código:</strong> ${this.registroSeleccionado.codigo}</p>
            <p><strong>Descripción:</strong> ${this.registroSeleccionado.descripcion}</p>
            <hr>
            <p class="text-secondary">
              <strong>Observación:</strong> ${this.observacion}
            </p>
          </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6c757d",
        cancelButtonColor:  "#adb5bd",
        confirmButtonText:  "Sí, confirmar",
        cancelButtonText:   "Cancelar",
      });

      if (!result.isConfirmed) return;

      this.procesandoMapeo = true;
      try {
        await api.post("/procedimientos/mapear-elementos", null, {
          params: {
            idTramite:   this.p_idTramite,
            codigo:      String(this.registroSeleccionado.codigo),
            descripcion: this.registroSeleccionado.descripcion,
            idElemento:  0,                        // ← 0 siempre se serializa en la URL
            idPrestador: this.p_idPrestador,
            aplicable:   this.aplicable,
            observacion: this.observacion,
          },
        });
        await Swal.fire({
          icon: "success",
          title: "¡Registrado!",
          text: "Elemento marcado como no aplicable",
          confirmButtonColor: "#6c757d",
          timer: 2000,
        });
        this.cerrarModal();
        await this.cargarDatos();
      } catch (err) {
        console.error("Error en mapeo no aplicable:", err);
        Swal.fire({
          icon: "error",
          title: "Error al procesar",
          text: err.response?.data?.message || err.message || "Error desconocido",
          confirmButtonColor: "#dc3545",
        });
      } finally {
        this.procesandoMapeo = false;
      }
    },

    // ── Confirmación visual reutilizable ──────────────────────────────────
    async _confirmarMapeo(colorClass, icono, nombreElemento) {
      return Swal.fire({
        title: "¿Confirmar mapeo?",
        html: `
          <div class="text-start">
            <p><strong>Código:</strong> ${this.registroSeleccionado.codigo}</p>
            <p><strong>Descripción:</strong> ${this.registroSeleccionado.descripcion}</p>
            <hr>
            <p class="${colorClass}">
              <strong>Mapear a:</strong> ${nombreElemento}
            </p>
            <p class="text-muted small mb-1">
              <strong>Aplicable:</strong> ${this.aplicable === 1 ? "Sí" : "No"}
            </p>
            ${this.observacion
              ? `<p class="text-muted small mb-0"><strong>Observación:</strong> ${this.observacion}</p>`
              : ""}
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, mapear",
        cancelButtonText:  "Cancelar",
        cancelButtonColor: "#6c757d",
      });
    },

    // ── Mapeos ────────────────────────────────────────────────────────────

    async mapearMedicamento() {
      if (!this.medicamentoSeleccionado) return;
      const result = await this._confirmarMapeo(
        "text-success",
        "medication",
        `${this.medicamentoSeleccionado.codigo} - ${this.medicamentoSeleccionado.nombre}`
      );
      if (!result.isConfirmed) return;
      this.procesandoMapeo = true;
      try {
        await api.post("/procedimientos/mapear-elementos", null, {
          params: this._paramsMapeo(this.medicamentoSeleccionado.idElemento),
        });
        await Swal.fire({
          icon: "success", title: "¡Éxito!",
          text: "Medicamento mapeado correctamente",
          confirmButtonColor: "#198754", timer: 2000,
        });
        this.cerrarModal();
        await this.cargarDatos();
      } catch (err) {
        console.error("Error mapeando medicamento:", err);
        Swal.fire({
          icon: "error", title: "Error al mapear",
          text: err.response?.data?.message || err.message || "Error desconocido",
          confirmButtonColor: "#dc3545",
        });
      } finally {
        this.procesandoMapeo = false;
      }
    },

    async mapearInsumo() {
      if (!this.insumoSeleccionado) return;
      const result = await this._confirmarMapeo(
        "text-warning",
        "inventory_2",
        `${this.insumoSeleccionado.codigo} - ${this.insumoSeleccionado.nombre}`
      );
      if (!result.isConfirmed) return;
      this.procesandoMapeo = true;
      try {
        await api.post("/procedimientos/mapear-elementos", null, {
          params: this._paramsMapeo(this.insumoSeleccionado.idElemento),
        });
        await Swal.fire({
          icon: "success", title: "¡Éxito!",
          text: "Insumo mapeado correctamente",
          confirmButtonColor: "#ffc107", timer: 2000,
        });
        this.cerrarModal();
        await this.cargarDatos();
      } catch (err) {
        console.error("Error mapeando insumo:", err);
        Swal.fire({
          icon: "error", title: "Error al mapear",
          text: err.response?.data?.message || err.message || "Error desconocido",
          confirmButtonColor: "#dc3545",
        });
      } finally {
        this.procesandoMapeo = false;
      }
    },

    async mapearPrestacion() {
      if (!this.prestacionSeleccionada) return;
      const result = await this._confirmarMapeo(
        "text-info",
        "medical_services",
        `${this.prestacionSeleccionada.elementoCodigo} - ${this.prestacionSeleccionada.elementoNombre}`
      );
      if (!result.isConfirmed) return;
      this.procesandoMapeo = true;
      try {
        await api.post("/procedimientos/mapear-elementos", null, {
          params: this._paramsMapeo(this.prestacionSeleccionada.idElemento),
        });
        await Swal.fire({
          icon: "success", title: "¡Éxito!",
          text: "Prestación mapeada correctamente",
          confirmButtonColor: "#0dcaf0", timer: 2000,
        });
        this.cerrarModal();
        await this.cargarDatos();
      } catch (err) {
        console.error("Error mapeando prestación:", err);
        Swal.fire({
          icon: "error", title: "Error al mapear",
          text: err.response?.data?.message || err.message || "Error desconocido",
          confirmButtonColor: "#dc3545",
        });
      } finally {
        this.procesandoMapeo = false;
      }
    },
  },
};
</script>

<style scoped>
.hover-row:hover {
  background-color: #f8f9fa;
}
.tablaBusqueda {
  width: 100%;
}
.tablaBusqueda td {
  padding: 0.5rem;
}
.tablaBusqueda td.centro {
  text-align: center;
  vertical-align: bottom;
}
.pagination {
  margin-bottom: 0.5rem;
}
.material-icons {
  vertical-align: middle;
}
.info-registro {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 0.5rem;
  border-left: 4px solid #0d6efd;
}
.nav-tabs .nav-link {
  font-weight: 500;
  color: #6c757d;
}
.nav-tabs .nav-link.active {
  font-weight: 600;
}
.nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.form-control-lg,
.form-select-lg {
  font-size: 1rem;
}
.form-select[size] option {
  padding: 0.5rem;
}
</style>